import { __extends } from "tslib";
import React from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { ContentWithCopy } from "../../ContentWithCopy";
import { SplitButtonDropDown } from "../../SplitButtonDropDown";
import { Languages } from "../../../constants/languages";
import { ITranslations } from "../../../models/translations";
import { IReportBuilderState } from "../../../state/reducers";
import { generateCUrl } from "../../../utils/UrlUtils";
var viewRequestModalCssClasses = {
    overlay: "rb-modal-overlay",
    modal: "rb-modal",
    closeButton: "rb-close-button",
};
var ViewRequestOptions;
(function (ViewRequestOptions) {
    ViewRequestOptions["payload"] = "payload";
    ViewRequestOptions["curl"] = "curl";
})(ViewRequestOptions || (ViewRequestOptions = {}));
var ViewRequest = (function (_super) {
    __extends(ViewRequest, _super);
    function ViewRequest(props) {
        var _this = _super.call(this, props) || this;
        _this.getOptions = function () {
            var t = _this.props.t;
            return new Map([
                [ViewRequestOptions.payload, t.viewRequestPayload],
                [ViewRequestOptions.curl, t.viewRequestAsCURL],
            ]);
        };
        _this.onSelect = function (newSelected) {
            _this.setState({
                selected: newSelected,
            });
            _this.onOpenModal();
        };
        _this.onOpenModal = function () {
            _this.setState({
                isOpen: true,
            });
        };
        _this.onCloseModal = function () {
            _this.setState({
                isOpen: false,
            });
        };
        _this.state = {
            isOpen: false,
            selected: ViewRequestOptions.payload,
        };
        return _this;
    }
    ViewRequest.prototype.render = function () {
        return (React.createElement("div", { className: "rb-view-request-dropdown-container" },
            React.createElement(SplitButtonDropDown, { id: "rb-view-request-dropdown", value: ViewRequestOptions.payload, options: this.getOptions(), onSelect: this.onSelect }),
            this.renderViewRequestModal()));
    };
    ViewRequest.prototype.renderViewRequestModal = function () {
        var _a = this.state, isOpen = _a.isOpen, selected = _a.selected;
        var _b = this.props, request = _b.request, t = _b.t;
        var options = this.getOptions();
        if (!request) {
            return null;
        }
        var body = null;
        var title = null;
        var language = null;
        switch (selected) {
            case ViewRequestOptions.payload:
                body = request;
                title = options.get(ViewRequestOptions.payload);
                language = Languages.json;
                break;
            case ViewRequestOptions.curl:
                body = generateCUrl(JSON.stringify(request), "/data/get", this.props.baseURL || window.location.origin + "/datagateway/rest/v1");
                title = options.get(ViewRequestOptions.curl);
                language = Languages.powershell;
                break;
            default:
        }
        if (typeof body !== "string") {
            body = JSON.stringify(body, null, 2);
        }
        return (React.createElement(Modal, { classNames: viewRequestModalCssClasses, open: isOpen, onClose: this.onCloseModal, closeIconSize: 25, animationDuration: 300 },
            React.createElement("div", { className: "rb-title-dark rb-title-medium" }, title),
            React.createElement(ContentWithCopy, { body: body, language: language, t: t })));
    };
    return ViewRequest;
}(React.PureComponent));
var connected = connect(function (state) {
    var request = state.request, translations = state.translations;
    return {
        request: request,
        t: translations,
    };
})(ViewRequest);
export { connected as ViewRequest };
